module.exports = __webpack_public_path__ + "static/media/wave-simulator.png";